import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PropTypes } from "prop-types";
import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const UnsupportedVariablesWarning = ({
  show,
  warning,
  onReview,
  onSaveAnyway,
  saving = false,
}) => {
  const parentModalRef = React.useRef(null);
  const suspendParentFocus = React.useCallback(() => {
    const $parentModal = $(".modal.show")
      .not(".unsupported-variables-warning-overlay")
      .filter((_index, element) => !!$(element).data("bs.modal"))
      .last();
    const parentModal = $parentModal.data("bs.modal");

    if (!parentModal || typeof parentModal._enforceFocus !== "function") {
      return;
    }

    $(document).off("focusin.bs.modal");
    parentModalRef.current = {
      element: $parentModal[0],
      instance: parentModal,
    };
  }, []);
  const restoreParentFocus = React.useCallback(() => {
    const parentModal = parentModalRef.current;
    parentModalRef.current = null;

    if (parentModal && $(parentModal.element).hasClass("show")) {
      parentModal.instance._enforceFocus();
    }
  }, []);
  React.useEffect(() => restoreParentFocus, [restoreParentFocus]);
  const tokens = warning?.tokens || [];
  let body =
    "Variables could not be validated. Save anyway only if you want to keep the text as written.";
  if (!warning?.validationUnavailable) {
    body = tokens.length
      ? `These tokens are not supported in this context: ${tokens.join(", ")}. Remove them or save anyway to keep the text as written.`
      : "Some variables are not supported in this context. Remove them or save anyway to keep the text as written.";
  }
  const title = warning?.validationUnavailable
    ? "Variables could not be validated"
    : "Some variables will not render";

  return (
    <Modal
      show={show}
      onShow={suspendParentFocus}
      onHide={onReview}
      onExited={restoreParentFocus}
      backdrop="static"
      keyboard={!saving}
      className="unsupported-variables-warning-overlay"
      backdropClassName="unsupported-variables-warning-backdrop"
    >
      <Modal.Header closeButton={!saving}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="alert alert-warning mb0">
          <FontAwesomeIcon
            icon={["far", "fa-exclamation-triangle"]}
            className="mr5"
          />
          <span className="text-break">{body}</span>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onReview} disabled={saving}>
          Review tokens
        </Button>
        <Button variant="primary" onClick={onSaveAnyway} disabled={saving}>
          {saving ? "Saving..." : "Save anyway"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

UnsupportedVariablesWarning.propTypes = {
  show: PropTypes.bool.isRequired,
  warning: PropTypes.shape({
    tokens: PropTypes.arrayOf(PropTypes.string),
    validationUnavailable: PropTypes.bool,
  }),
  onReview: PropTypes.func.isRequired,
  onSaveAnyway: PropTypes.func.isRequired,
  saving: PropTypes.bool,
};

export default UnsupportedVariablesWarning;
